import useMutationCall from "../../../hooks/useMutationCall";
import { useStartMutation } from "../checkInSlice";

const useCheckInStart = () => {
  return useMutationCall(useStartMutation);
};

export default useCheckInStart;
